import { indexItems } from '@/mocks/homeData';

export default function IndexSection() {
  return (
    <section id="index" className="py-14 md:py-20 px-4 md:px-6 bg-background-100">
      <div className="w-full max-w-[1280px] mx-auto">
        <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-100 text-center mb-3">
          分类索引
        </h2>
        <p className="text-foreground-400 text-sm text-center mb-10">
          按类型快速浏览，精准找到你想看的影片
        </p>

        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-3 md:gap-4">
          {indexItems.map((item, idx) => (
            <div
              key={item.label}
              className="group bg-background-50 border border-background-200/30 rounded-xl p-5 hover:border-primary-500/30 transition-all duration-300 cursor-pointer"
              style={{ animationDelay: `${idx * 50}ms` }}
            >
              <div className="w-10 h-10 flex items-center justify-center rounded-lg bg-primary-500/10 text-primary-500 mb-3 group-hover:bg-primary-500/15 transition-colors">
                <i className={`${item.icon} text-xl`}></i>
              </div>
              <h3 className="text-sm font-bold text-foreground-100 mb-1 whitespace-nowrap">
                {item.label}
              </h3>
              <p className="text-xs text-foreground-500">{item.count}部影片</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}